import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import cx from 'classnames';
import Link from '@material-ui/core/Link';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import CellValue from './CellValue';
import { rowHeight } from '../constants';
import { useDispatch } from 'react-redux';
import { fetchRecalledErrorForOne } from 'features/PpsiContainer/actions';

const useStyles = makeStyles(theme => ({
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  tableRow: {
    cursor: 'pointer'
  },
  tableRowHover: {
    '&:hover': {
      backgroundColor: theme.palette.grey[200]
    }
  },
  tableCell: {
    flex: 1,
    border: 0
  },
  noClick: {
    cursor: 'initial'
  }
}));

// Prevent onRowClick on table to be fired
const stopPropagation = event => {
  event.stopPropagation();
};

const Cell = ({ cellData, columnData, rowData }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const columnConfig = columnData.config;
  const route = columnConfig.link ? columnConfig.link(rowData.data) : null;
  const cellStyle = columnConfig.style ? columnConfig.style(rowData.data) : {};
  // const isCallback = columnConfig.funCall ? dispatch(fetchRecalledErrorForOne(rowData.id, history)) : ()=>{};

  const cellValue = (
    <CellValue
      cellData={cellData}
      columnConfig={columnConfig}
      rowData={rowData}
    />
  );
  return (
    <TableCell
      component="div"
      className={cx(classes.tableCell, classes.flexContainer)}
      variant="body"
      style={{ height: rowHeight, ...cellStyle }}
      onClick={() => {
        if (columnConfig.funCall) {
          dispatch(fetchRecalledErrorForOne(rowData.id, history));
        }
        // columnConfig.funCall ?  : ()=>{}
      }}
    >
      {route && (
        <Link
          to={route}
          style={{ ...cellStyle }}
          component={RouterLink}
          onClick={stopPropagation}
        >
          {cellValue}
        </Link>
      )}
      {!route && cellValue}
    </TableCell>
  );
};

export default Cell;
